import { I18n } from "@assets/strings";
import React from "react";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { Stack } from "@ui/components/layout";
import { ApplicationFileInformation } from "@ui/components/application/applicationFileInformation";
import { ApplicationInformationContainer } from "@ui/components/application/applicationInformationContainer";
import { SummaryViewProps } from "@ui/components/application/summaryView";

export const VideoTeasingSectionSummaryView: React.FC<SummaryViewProps> = ({ application, ...htmlProps }) => {
	return (
		<Stack gap={20} style={{ width: "100%" }} {...htmlProps}>
			<ApplicationInformationContainer isDocument>
				<PrimaryMedium>{I18n.t(`application.form.video_story.label`)}</PrimaryMedium>
				<ApplicationFileInformation>{application.videoId?.displayName}</ApplicationFileInformation>
			</ApplicationInformationContainer>
		</Stack>
	);
};
